import React from 'react';
import { Badge } from 'react-bootstrap';

const STATUS_COLORS = {
  new: 'primary',
  open: 'warning',
  pending: 'info',
  solved: 'success',
  closed: 'secondary',
};

export default function TicketHeader({ ticket, onBack }) {
  return (
    <div className="ticket-header">
      <button className="ticket-header-back" onClick={onBack} title="Back to Tickets">
        &larr;
      </button>
      <span className="ticket-number">#{ticket.ticket_number}</span>
      <h5>{ticket.subject}</h5>
      <Badge bg={STATUS_COLORS[ticket.status] || 'secondary'} style={{ fontSize: '0.75rem', marginLeft: 'auto' }}>
        {ticket.status}
      </Badge>
    </div>
  );
}
